const selectors = {
  form: '#unsubscribeForm',
  email: '#customer_email',
  phone: '#customer_phone',
  error: '.js-error-message',
  reasonError: '.js-reason-error',
  success: '.js-success-message'
}

const handleSubmit = event => {
  const form = event.target.closest(selectors.form)

  if (!form) return;

  event.preventDefault();

  const formData = new FormData(form)
  const payload = Object.fromEntries(formData)

  if (!payload.reason) {
    form.querySelector(selectors.reasonError).removeAttribute('hidden')
    
    return;
  } else {
    form.querySelector(selectors.reasonError).setAttribute('hidden', true)
  }
  
  if (!payload.email && !payload.phone) {
    form.querySelector(selectors.error).removeAttribute('hidden')

    return;
  }

  form.querySelector(selectors.error).setAttribute('hidden', true)

  fetch('https://tftw-meineinkauf.herokuapp.com/api/v1/unsubscribes', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  }).then(res => res.json())
  .then(() => {
    document.querySelector(selectors.success).removeAttribute('hidden')
    form.setAttribute('hidden', true)
  }).catch(err => {
    console.log(err)
  })
}

document.addEventListener('submit', handleSubmit)
